import Helper from './Helper';
class ScrollSpy {
	constructor(config = {}) {
		const { header } = config;

		this.header = document.querySelector(header || "header");
		this.language = document.querySelector('html').getAttribute('lang');

		if ( this.language === 'de-DE') {
			this.backToTopText = 'Nach oben scrollen';
		} else {
			this.backToTopText = 'Back to top';
		}

		this.lastScrollPos = 0;
		this.createBackToTop();
		this.registerScroll();
    this.setMarginTop(window);
    this.bttpVisible = false;
	}

	createBackToTop(){
		this.bttp = document.createElement('div');
		Helper.addClass(this.bttp, 'back-to-top');
		this.bttp.innerHTML = `<div class="back-to-top__inner"><button type="button" class="nhs-btn nhs-fancy-btn back-to-top__button" aria-label="${this.backToTopText}">
														<span class="nhs-fancy-btn__inner">
															<svg version="1.1" class="back-to-top__arrow" id="arrow-up" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
																<g transform="translate(5.000000, 0.000000)">
																	<path style="stroke-width:2;stroke:currentColor" d="M20,40V12"/>
																	<polyline style="fill:currentColor" points="28,18.7 26.6,20 20,12.9 13.4,20 12,18.7 20,10 28,18.7 	"/>
																</g>
															</svg>
														</span>
											</button></div>`;
		document.querySelector('body').appendChild(this.bttp);
		this.bttp.querySelector('button').addEventListener('click', e => {
			window.scroll({top: 0, left: 0, behavior: 'smooth' });
		});
	}

	setMarginTop(window) {
		let el = this.header;

		function setMargin(el) {
			let height = el.offsetHeight;
      document.querySelector(".header-spacer").style.height = height + "px";
		}

		setMargin(el);
		window.addEventListener("resize", e => {
			// console.log('resize');
			setMargin(el);
		});

		window.addEventListener("orientationchange", () => {
			setMargin(el);
		}, false);
	}

	registerScroll() {
		// console.log('registerscroll');
		window.addEventListener("scroll", e => {
			// console.log('scrolling');
			this.handleScroll(e);
		});
	}

	handleScroll(e) {
		const body = document.body;
		const html = document.documentElement;

		this.maxHeight = Math.max(
			body.scrollHeight,
			body.offsetHeight,
			html.clientHeight,
			html.scrollHeight,
			html.offsetHeight
		);

		this.windowHeight = window.innerHeight;

		// console.log("handlescroll");
		let scrollTop = e.currentTarget.pageYOffset;
		let element = e.target;
		let height = this.header.offsetHeight;
		const h = this.header;
		let scrolledUp = false;

		// if (scrollTop == 0 && scrolledUp == true){
		// 	console.log(scrolledUp);
		// 	scrolledUp = false;
		// 	h.classList.remove("js-header--full");
		// 	h.classList.remove("js-header--hide");
		// 	h.classList.remove("js-header--show");
		// }

		if (this.lastScrollPos < (height) && scrolledUp == false) {
			// console.log('static');
			this.lastScrollPos = scrollTop;
			scrolledUp = false;
			// console.log(scrolledUp);
			h.classList.remove("js-header--full");
			h.classList.remove("js-header--hide");
			h.classList.remove("js-header--show");
			this.hideBTT();
		} else if (this.lastScrollPos < (height + 1000) && scrolledUp == false){
			// console.log('show only');
			this.lastScrollPos = scrollTop;
			scrolledUp = false;
			// console.log(scrolledUp);
			h.classList.remove("js-header--full");
			h.classList.remove("js-header--hide");
			h.classList.add("js-header--show");
			this.hideBTT();
			// Helper.addClass(this.bttp, 'bttp--visible');
		}


		if (this.lastScrollPos < height && scrolledUp == true) {
			// console.log('scroll within top area');
			this.lastScrollPos = scrollTop;
			scrolledUp = false;
			// console.log(scrolledUp);
			h.classList.add("js-header--full");
			h.classList.remove("js-header--hide");
			h.classList.remove("js-header--show");
			this.hideBTT();
		}

		if (this.lastScrollPos < scrollTop) {
			this.lastScrollPos = scrollTop;
			// console.log('scrolled down enough to have scrolling stuff happen');
			h.classList.add("js-header--hide");
			// h.classList.remove("js-header--show");
			h.classList.remove("js-header--full");
			this.hideBTT();
			scrolledUp = false;
			// console.log(scrolledUp);
		}

		if (this.lastScrollPos > scrollTop) {
			this.lastScrollPos = scrollTop;
			// console.log('scroll up');
			h.classList.add("js-header--show");
			h.classList.remove("js-header--hide");
			h.classList.remove("js-header--full");
			this.showBTT();
			scrolledUp = true;
			// console.log(scrolledUp);
		}

		if (this.maxHeight - this.windowHeight - 1 <= scrollTop) {
			this.lastScrollPos = scrollTop;
			// console.log('bottom of page');
			h.classList.add("js-header--show");
			this.showBTT();
			h.classList.remove("js-header--full");
			h.classList.remove("js-header--hide");
			scrolledUp = false;
			// console.log(scrolledUp);
		}
  }

  showBTT(){
    if(!this.bttpVisible){
      Helper.addClass(this.bttp, 'bttp--visible');
      this.bttp.style.opacity = 1;
      this.bttp.animate([
        // keyframes
        {
          opacity: 0
        },
        {
          opacity: 1
        }
      ], {
        // timing options
        duration: 400,
        iterations: 1
      });
      setTimeout(() => { this.bttpVisible = true; }, 400);
    }
  }

  hideBTT(){
    if(this.bttpVisible){
      this.bttp.style.opacity = 0;
      this.bttp.animate([
        // keyframes
        {
          opacity: 1
        },
        {
          opacity: 0
        }
      ], {
        // timing options
        duration: 400,
        iterations: 1
      });

      setTimeout(() => { this.bttpVisible = false;; Helper.removeClass(this.bttp, 'bttp--visible') }, 400);
    }
  }
}

export default ScrollSpy;
